const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio!';
  }

  if (values.linkedUsers === null || values.linkedUsers === []) {
    errors.linkedUsers = 'Esse campo não pode ficar vazio!';
  }

  if (values.profileFeatures) {
    if (!values.profileFeatures.some((feature) => feature.hasAcess)) {
      errors.profileFeatures = 'Esse campo não pode ficar vazio!';
    }
  }
  return errors;
};
export default validate;
